// extracted by mini-css-extract-plugin
module.exports = {"message":"DownloadStatementModal_message__QIo-Y"};